import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation";
import Head from "next/head";
import { useEffect } from "react";
const HubspotEmbed = ({
  region = "na1",
  portalId,
  embedId,
  elementId,
  sfdcCampaignId
}) => {
  useEffect(() => {
    const createContent = () => {
      if (window.hbspt) {
        window.hbspt.content.create({
          region,
          portalId,
          embedId,
          elementId,
          sfdcCampaignId
        });
      }
    };
    if (window.hbspt) {
      createContent();
    } else {
      const script = document.getElementById("hs-embed");
      if (script) {
        script.onload = createContent;
      }
    }
  }, [region, portalId, embedId, elementId, sfdcCampaignId]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx("script", { id: "hs-embed", src: "https://js.hubspot.com/content-embed/v1.js", async: true }) }),
    /* @__PURE__ */ jsx(Box, { id: elementId, sx: {
      minHeight: "400px"
    }, "data-testid": "hubspot-embed-container" })
  ] });
};
export {
  HubspotEmbed as default
};
